import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Petas mi, ne serĉu vane min, <br/>
        Mi foriris por la urb-vagad’, <br/>
        Duonombre, duonlume <br/>
        Kvazaŭ en profunda plonĝ’. <br/>
        Kaj mi savos de soleco <br/>
        Tiujn stratojn kaj kortetojn, <br/>
        Forgesitajn de la domoj <br/>
        Por ripoz’ kaj bela sonĝ’.
      </p>

      <p class="poem-block mb-3">
        Mi foriris por la urb-vagad’, <br/>
        Venton kaj senventon sentis por <br/>
        Varma pluv’ forviŝu lante <br/>
        Miajn spurojn de la strat’. <br/>
        Petas mi, ne serĉu vane min, <br/>
        Ĉar nenie plu ekzistas mi, <br/>
        Logis min la urb’ vespera, <br/>
        Nigra regno sen kompat’.
      </p>

      <p class="poem-block mb-3">
        Dronos mi sen guto da aer’, <br/>
        Arde flustras vortojn urb’ al mi, <br/>
        De fabel’ kaj sorĉ’ freneza ret’ <br/>
        Kaptas min, ĝis mi senspure <br/>
        Dissolviĝas en nebul’, <br/>
        Ĉirkaŭvolvis kaj brakumis min, <br/>
        Baris vojon por forkur’ kaj sav’. <br/>
        Vage dronas en tenebro mi, <br/>
        Ne penetros ĝin okul’.
      </p>

      <p class="poem-block mb-3">
        Se vi vidos, ke pereis mi, <br/>
        Ke ekdormis – ne vekiĝis plu, <br/>
        Vi ne kredu ja, amato, <br/>
        Kaj ne ploru en angor’. <br/>
        Nek la mort’, nek dormo trafis min, – <br/>
        Mi foriris por la urb-vagad’ <br/>
        Kaj senbrue fermis pordon, <br/>
        Dum ne venis la aŭror’.
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Promenado tra la urbo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['WF22jSiCpPk'], 
    itemTranslator: translator.esp
  }
}

export default item;